import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from '../../Internals/BaseButton';

const PrimaryButton = ({
  children,
  color,
  background,
  showBorder,
  size,
  style,
  className,
  ...props
}) => {
  const borderValue = showBorder ? '1px solid' : 'none';
  const btnStyle = {
    color,
    borderColor: color,
    background,
    border: borderValue,
    ...style
  };

  return (
    <BaseButton className={`primaryButton ${className || ''}`} style={btnStyle} {...props}>
      {children}
    </BaseButton>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.any.isRequired,
  color: PropTypes.string,
  background: PropTypes.string,
  size: PropTypes.string,
  showBorder: PropTypes.bool
};

PrimaryButton.defaultProps = {
  children: '',
  color: 'black',
  background: 'none',
  showBorder: false,
  size: ''
};

export default PrimaryButton;
